var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'alert-message text-center' : true, [`alert-${_vm.type}`] : _vm.type}},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.content)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }